exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".wordCloud{display:inline-block;position:relative;width:100%;height:400px}.wordCloud svg{display:inline-block;position:absolute;top:0;left:0}div.tooltip{position:absolute;width:140px;height:50px;padding:8px;font:18px Arial;line-height:24px;color:#fff;background:#000;border:0;border-radius:2px;pointer-events:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e81514d4","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/WordCloud.vue
// module id = 177
// module chunks = 0